import agreements from 'views/profile/user/agreements';

export default {
	...agreements,
};
